import React, { useEffect, useRef, useState } from 'react';
import invariant from 'tiny-invariant';
import {
    draggable,
    dropTargetForElements,
} from '@atlaskit/pragmatic-drag-and-drop/element/adapter';
import { combine } from '@atlaskit/pragmatic-drag-and-drop/combine';
import { attachClosestEdge } from '@atlaskit/pragmatic-drag-and-drop-hitbox/closest-edge';

import { useAppSelector } from '../../store/hooks';
import { selectSources } from '../../store/slices/mapSlice';
import ScoutButton from '../scoutButton';
import propertyImage from '../../img/home.png';
import './kanbanProjectCard.css';

const KanbanProjectCard = ({ item }) => {
    const cardRef = useRef(null);
    const sourcesDictionary = useAppSelector(selectSources);
    const [isDragging, setIsDragging] = useState(false);

    const { id, kanbanId, alt_name, city_name: city, aro_id, source } = item;
    const sourceName = sourcesDictionary[source];
    const dndId = String(kanbanId);

    useEffect(() => {
        const cardEl = cardRef.current;
        invariant(cardEl);

        return combine(
            draggable({
                element: cardEl,
                getInitialData: () => ({ type: 'card', cardId: kanbanId }),
                onDragStart: () => setIsDragging(true),
                onDrop: () => setIsDragging(false),
            }),
            dropTargetForElements({
                element: cardEl,
                getData: ({ input, element }) => {
                    const data = { type: 'card', cardId: kanbanId };
                    return attachClosestEdge(data, {
                        input,
                        element,
                        allowedEdges: ['top', 'bottom'],
                    });
                },
                getIsSticky: () => true,
            })
        );
    }, [kanbanId]);

    return (
        <div
            id={dndId}
            ref={cardRef}
            className={`px-1 pt-2 pb-1 rounded-3  ${
                isDragging ? 'kanbanProjectCardDragging' : 'kanbanProjectCard'
            }`}
        >
            <div className="row">
                <div
                    className="col-3 pt-0 pb-0 text-center"
                    style={{ paddingLeft: 0, paddingRight: 0 }}
                >
                    <img src={propertyImage} draggable={false} width="50" />
                    <div className="fw-bold propSource">{sourceName}</div>
                </div>
                <div
                    className="col-9 d-flex flex-column gap-1 pt-0 pr-1 pb-0 projInfo text-capitalize"
                    style={{ paddingLeft: 0 }}
                >
                    <div>
                        <div className="d-flex justify-content-between">
                            <div>
                                <div className="projName lh-1 fw-bolder">
                                    {alt_name.toLowerCase()}
                                </div>
                                <div className="fst-italic">{city.toLowerCase()}</div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-0 mt-xl-1 d-flex flex-lg-column flex-xl-row gap-2 gap-md-1 justify-content-between align-items-center align-items-md-start align-items-xl-center">
                        <ScoutButton propertyId={id} />
                        <div className="pt-1 pe-1" style={{ fontSize: '12px' }}>
                            {aro_id}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default KanbanProjectCard;
